import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row, Table } from 'reactstrap';
import { byteSize, Translate, ICrudGetAllAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntities } from './zixun.reducer';
import { IZixun } from 'app/shared/model/zixun.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IZixunProps extends StateProps, DispatchProps, RouteComponentProps<{ url: string }> {}

export const Zixun = (props: IZixunProps) => {
  useEffect(() => {
    props.getEntities();
  }, []);

  const { zixunList, match, loading } = props;
  return (
    <div>
      <h2 id="zixun-heading">
        <Translate contentKey="examsysApp.zixun.home.title">Zixuns</Translate>
        <Link to={`${match.url}/new`} className="btn btn-primary float-right jh-create-entity" id="jh-create-entity">
          <FontAwesomeIcon icon="plus" />
          &nbsp;
          <Translate contentKey="examsysApp.zixun.home.createLabel">Create new Zixun</Translate>
        </Link>
      </h2>
      <div className="table-responsive">
        {zixunList && zixunList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="global.field.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="examsysApp.zixun.title">Title</Translate>
                </th>
                <th>
                  <Translate contentKey="examsysApp.zixun.time">Time</Translate>
                </th>
                <th>
                  <Translate contentKey="examsysApp.zixun.isTop">Is Top</Translate>
                </th>
                <th>
                  <Translate contentKey="examsysApp.zixun.author">Author</Translate>
                </th>
                {/*<th>*/}
                  {/*<Translate contentKey="examsysApp.zixun.content">Content</Translate>*/}
                {/*</th>*/}
                <th />
              </tr>
            </thead>
            <tbody>
              {zixunList.map((zixun, i) => (
                <tr key={`entity-${i}`}>
                  <td>
                    <Button tag={Link} to={`${match.url}/${zixun.id}`} color="link" size="sm">
                      {zixun.id}
                    </Button>
                  </td>
                  <td>{zixun.title}</td>
                  <td>{zixun.time}</td>
                  <td>{zixun.isTop ? 'true' : 'false'}</td>
                  <td>{zixun.author}</td>
                  {/*<td>{zixun.content}</td>*/}
                  <td className="text-right">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${zixun.id}`} color="info" size="sm">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${zixun.id}/edit`} color="primary" size="sm">
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${zixun.id}/delete`} color="danger" size="sm">
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="examsysApp.zixun.home.notFound">No Zixuns found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ zixun }: IRootState) => ({
  zixunList: zixun.entities,
  loading: zixun.loading,
});

const mapDispatchToProps = {
  getEntities,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(Zixun);
